function getAtomicElements(key: string): HTMLElement[] {
  return Array.from(document.querySelectorAll(`[data-atomic-update="${key}"]`));
}

type Key =
  | 'user.fullname'
  | 'messages_count'
  | 'appointments_count'
  | 'user_points';

/**
 * atomicUpdate updates dynamic sections of legacy DOM
 * @param key
 * @param value
 */
export function atomicUpdate(key: Key, value: string) {
  getAtomicElements(key).forEach(el => {
    el.innerText = value;
  });
}

type ImageKey = 'user.image';

export function atomicUpdateImg(key: ImageKey, src: string) {
  getAtomicElements(key).forEach(el => {
    if (el instanceof HTMLImageElement) {
      el.src = src;
    }
  });
}
